import { render, staticRenderFns } from "./TrademarkProvisionalCaseInstructionForm.vue?vue&type=template&id=5a852a3a&"
import script from "./TrademarkProvisionalCaseInstructionForm.vue?vue&type=script&lang=js&"
export * from "./TrademarkProvisionalCaseInstructionForm.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkProvisionalCaseInstructionForm.vue?vue&type=style&index=0&id=5a852a3a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports